<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-3 align-items-center">
      <div class="position-relative col-md-8">
        <input
          type="text"
          class="form-control ps-5 form-control-sm"
          :placeholder="t('settings.nationalities.searchPlaceholder')"
          v-model="term"
          @input="$emit('search', term)"
          :dir="locale === 'ar' ? 'rtl' : 'ltr'"
        />
        <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
          <i class="fas fa-search"></i>
        </span>
      </div>

      <div class="col-md-4">
        <button
          class="btn btn-secondary btn-sm w-100 d-flex align-items-center justify-content-center gap-2"
          @click="$emit('add')"
        >
          <i class="fas fa-plus"></i>
          <span>{{ t('settings.nationalities.addNew') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
const term = ref('')
</script>
